import type { VideoItem } from "@/types/video";

export const movieCategories = [
  "全部",
  "动作",
  "喜剧",
  "爱情",
  "科幻",
  "悬疑",
  "犯罪",
  "剧情",
  "动画",
  "战争",
  "奇幻",
];

export const tvCategories = [
  "全部",
  "剧情",
  "犯罪",
  "科幻",
  "悬疑",
  "古装",
  "爱情",
  "喜剧",
  "奇幻",
  "家庭",
];

export const regions = ["全部", "国产", "欧美", "日韩", "港台"];

export const years = ["全部", "2024", "2023", "2022", "2021", "2020", "更早"];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "流浪地球2",
    type: "movie",
    category: "科幻",
    region: "国产",
    year: 2023,
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20a%20Chinese%20science%20fiction%20disaster%20epic%2C%20frozen%20earth%20surface%20with%20a%20giant%20planetary%20engine%20rising%20into%20the%20sky%2C%20deep%20blue%20and%20amber%20cinematic%20tones%2C%20dramatic%20lighting%2C%20highly%20detailed%20vertical%20composition&width=400&height=600&seq=movie-01&orientation=portrait",
    description:
      "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健", "沙溢"],
    releaseDate: "2023-01-22",
    views: 9820000,
    duration: 173,
  },
  {
    id: 2,
    title: "满江红",
    type: "movie",
    category: "悬疑",
    region: "国产",
    year: 2023,
    rating: 7.0,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20a%20Chinese%20ancient%20palace%20suspense%20drama%2C%20red%20lanterns%20and%20dark%20courtyard%20at%20night%2C%20mysterious%20figure%20in%20ancient%20robe%2C%20deep%20red%20and%20ink%20black%20tones%2C%20cinematic%20lighting%2C%20vertical%20composition&width=400&height=600&seq=movie-02&orientation=portrait",
    description:
      "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进巨大阴谋之中。",
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    releaseDate: "2023-01-22",
    views: 7650000,
    duration: 159,
  },
  {
    id: 3,
    title: "孤注一掷",
    type: "movie",
    category: "犯罪",
    region: "国产",
    year: 2023,
    rating: 6.9,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20a%20crime%20thriller%2C%20dim%20underground%20office%20surrounded%20by%20screens%20and%20neon%20signals%2C%20tense%20solitary%20silhouette%2C%20cold%20teal%20and%20orange%20contrast%2C%20moody%20cinematic%20light%2C%20vertical%20composition&width=400&height=600&seq=movie-03&orientation=portrait",
    description:
      "电影取材自上万起真实诈骗案例，程序员潘生与模特安娜被海外高薪招聘吸引，出国淘金，却意外落入境外诈骗工厂的陷阱。为了逃离魔窟，他们展开了一场艰难的生死逃亡。",
    director: "申奥",
    cast: ["张艺兴", "金晨", "咏梅", "王传君"],
    releaseDate: "2023-08-08",
    views: 8120000,
    duration: 130,
  },
  {
    id: 4,
    title: "消失的她",
    type: "movie",
    category: "悬疑",
    region: "国产",
    year: 2023,
    rating: 6.5,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20a%20romantic%20suspense%20film%2C%20lone%20woman%20standing%20by%20a%20dark%20tropical%20sea%20at%20dusk%2C%20foggy%20palms%2C%20muted%20teal%20and%20warm%20lamp%20glow%2C%20elegant%20melancholic%20mood%2C%20vertical%20cinematic%20composition&width=400&height=600&seq=movie-04&orientation=portrait",
    description:
      "何非的妻子李木子在结婚周年旅行中离奇消失，就在何非苦苦寻找无果时，妻子再次现身。但何非坚称眼前的陌生女人并非妻子，而对方却拿出了所有身份证明。真相远没有想象中简单。",
    director: "崔睿",
    cast: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    releaseDate: "2023-06-22",
    views: 6940000,
    duration: 122,
  },
  {
    id: 5,
    title: "封神第一部",
    type: "movie",
    category: "奇幻",
    region: "国产",
    year: 2023,
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20a%20Chinese%20mythological%20fantasy%20epic%2C%20ancient%20bronze%20army%20and%20immortal%20mountain%20in%20clouds%2C%20golden%20divine%20light%2C%20dark%20epic%20tones%20with%20jade%20green%2C%20grand%20detailed%20vertical%20composition&width=400&height=600&seq=movie-05&orientation=portrait",
    description:
      "商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主，以救苍生。西伯侯之子姬发逐渐发现殷寿的真面目，反出朝歌。",
    director: "乌尔善",
    cast: ["费翔", "李雪健", "黄渤", "于适"],
    releaseDate: "2023-07-20",
    views: 7310000,
    duration: 148,
  },
  {
    id: 6,
    title: "长津湖",
    type: "movie",
    category: "战争",
    region: "国产",
    year: 2021,
    rating: 7.4,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20a%20war%20epic%2C%20soldiers%20marching%20through%20snowy%20mountains%20at%20dawn%2C%20cold%20blue%20snow%20and%20warm%20bugle%20flame%2C%20solemn%20heroic%20mood%2C%20cinematic%20lighting%2C%20vertical%20composition&width=400&height=600&seq=movie-06&orientation=portrait",
    description:
      "1950年，中国人民志愿军部队与美军在朝鲜长津湖地区交战，志愿军将士在冰天雪地中顽强作战，以钢铁般的意志扭转战场态势，打出了新中国的国威军威。",
    director: "陈凯歌",
    cast: ["吴京", "易烊千玺", "段奕宏", "朱亚文"],
    releaseDate: "2021-09-30",
    views: 6580000,
    duration: 176,
  },
  {
    id: 7,
    title: "你好，李焕英",
    type: "movie",
    category: "喜剧",
    region: "国产",
    year: 2021,
    rating: 7.7,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20a%20warm%20family%20comedy%20drama%2C%20mother%20and%20daughter%20in%201980s%20Chinese%20factory%20town%2C%20sunlit%20nostalgic%20warm%20amber%20tones%2C%20soft%20film%20grain%2C%20emotional%20vertical%20composition&width=400&height=600&seq=movie-07&orientation=portrait",
    description:
      "2001年的某一天，刚刚考上大学的贾晓玲经历了人生中的一次大起大落。母亲突遭意外，悲痛万分的她意外穿越回1981年，与年轻的母亲李焕英相遇，展开一段温暖感人的故事。",
    director: "贾玲",
    cast: ["贾玲", "张小斐", "沈腾", "陈赫"],
    releaseDate: "2021-02-12",
    views: 6020000,
    duration: 128,
  },
  {
    id: 8,
    title: "战狼2",
    type: "movie",
    category: "动作",
    region: "国产",
    year: 2017,
    rating: 7.1,
    cover:
      "https://readdy.ai/api/search-image?query=Movie%20poster%20for%20an%20action%20military%20film%2C%20muscular%20soldier%20silhouette%20against%20exploding%20African%20savanna%20at%20sunset%2C%20dust%20and%20warm%20orange%20fire%20glow%2C%20powerful%20kinetic%20mood%2C%20vertical%20composition&width=400&height=600&seq=movie-08&orientation=portrait",
    description:
      "被开除军籍的冷锋卷入了一场非洲国家叛乱，本可以安全撤离，却因无法忘记曾经为军人的使命，孤身冲回沦陷区，带领身陷屠杀中的同胞和难民，展开生死逃亡。",
    director: "吴京",
    cast: ["吴京", "弗兰克·格里罗", "吴刚", "张翰"],
    releaseDate: "2017-07-27",
    views: 5410000,
    duration: 123,
  },
  {
    id: 9,
    title: "哪吒之魔童降世",
    type: "movie",
    category: "动画",
    region: "国产",
    year: 2019,
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20of%20a%20fiery%20mythical%20boy%20hero%20amid%20swirling%20flames%20and%20clouds%2C%20red%20and%20dark%20blue%20epic%20fantasy%20tones%2C%20dynamic%20energetic%20lighting%2C%20vivid%20vertical%20composition&width=400&height=600&seq=movie-09&orientation=portrait",
    description:
      "天地灵气孕育出一颗能量巨大的混元珠，元始天尊将其炼化成灵珠与魔丸。阴差阳错间，哪吒投胎成了魔丸转世。生而为魔，却逆天而行，喊出那句振聋发聩的“我命由我不由天”。",
    director: "饺子",
    cast: ["吕艳婷", "囧森瑟夫", "瀚墨", "陈浩"],
    releaseDate: "2019-07-26",
    views: 7230000,
    duration: 110,
  },
  {
    id: 10,
    title: "奥本海默",
    type: "movie",
    category: "剧情",
    region: "欧美",
    year: 2023,
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20biographical%20movie%20poster%20of%20a%20physicist%20silhouette%20before%20a%20huge%20orange%20mushroom%20cloud%2C%20dark%20desert%20night%2C%20black%20and%20amber%20tones%2C%20intense%20cinematic%20light%2C%20vertical%20composition&width=400&height=600&seq=movie-10&orientation=portrait",
    description:
      "影片聚焦“原子弹之父”罗伯特·奥本海默，讲述他在二战期间领导曼哈顿计划研制出世界上第一颗原子弹的传奇历程，以及此后在权力与良知之间不断挣扎的复杂人生。",
    director: "克里斯托弗·诺兰",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙", "小罗伯特·唐尼"],
    releaseDate: "2023-07-21",
    views: 6890000,
    duration: 180,
  },
  {
    id: 11,
    title: "沙丘2",
    type: "movie",
    category: "科幻",
    region: "欧美",
    year: 2024,
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20epic%20poster%20of%20a%20cloaked%20traveler%20walking%20vast%20golden%20desert%20dunes%20under%20a%20huge%20pale%20sun%2C%20sand%20storm%20haze%2C%20warm%20sand%20and%20cold%20blue%20tones%2C%20vertical%20composition&width=400&height=600&seq=movie-11&orientation=portrait",
    description:
      "保罗·厄崔迪与契妮和弗雷曼人联手，踏上复仇之路。当他面对一生所爱与已知宇宙命运的两难选择时，唯有竭力阻止只有他能预见的可怕未来。",
    director: "丹尼斯·维伦纽瓦",
    cast: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森", "哈维尔·巴登"],
    releaseDate: "2024-03-01",
    views: 7040000,
    duration: 166,
  },
  {
    id: 12,
    title: "蜘蛛侠：纵横宇宙",
    type: "movie",
    category: "动画",
    region: "欧美",
    year: 2023,
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20animated%20superhero%20poster%20of%20a%20masked%20spider%20hero%20leaping%20through%20a%20kaleidoscope%20of%20colorful%20multiverse%20portals%2C%20dynamic%20comic%20style%2C%20bold%20urban%20energy%2C%20vertical%20composition&width=400&height=600&seq=movie-12&orientation=portrait",
    description:
      "迈尔斯·莫拉莱斯穿越多元宇宙，遇见了由格温·斯泰西带领的蜘蛛侠团队。然而在如何应对新的威胁上，英雄们产生了巨大分歧，迈尔斯必须重新定义什么是真正的英雄。",
    director: "华金·多斯·桑托斯",
    cast: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    releaseDate: "2023-06-02",
    views: 6310000,
    duration: 140,
  },
  {
    id: 13,
    title: "蜘蛛侠：英雄无归",
    type: "movie",
    category: "动作",
    region: "欧美",
    year: 2021,
    rating: 7.6,
    cover:
      "https://readdy.ai/api/search-image?query=Superhero%20movie%20poster%20of%20a%20spider%20hero%20standing%20on%20a%20skyscraper%20ledge%20as%20a%20stormy%20portal%20opens%20over%20the%20city%2C%20red%20and%20deep%20blue%20tones%2C%20dramatic%20night%20lighting%2C%20vertical%20composition&width=400&height=600&seq=movie-13&orientation=portrait",
    description:
      "蜘蛛侠的身份被曝光后，生活陷入混乱。他求助奇异博士施展遗忘咒，却意外打开了多元宇宙的大门，引来了各个宇宙中最强大的反派，一场前所未有的危机随之而来。",
    director: "乔·沃茨",
    cast: ["汤姆·赫兰德", "赞达亚", "本尼迪克特·康伯巴奇"],
    releaseDate: "2021-12-17",
    views: 5880000,
    duration: 148,
  },
  {
    id: 14,
    title: "疾速追杀4",
    type: "movie",
    category: "动作",
    region: "欧美",
    year: 2023,
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=Neo%20noir%20action%20movie%20poster%20of%20a%20suited%20assassin%20walking%20through%20neon%20lit%20rainy%20city%20street%20at%20night%2C%20amber%20and%20cool%20blue%20neon%2C%20high%20contrast%20cinematic%20look%2C%20vertical%20composition&width=400&height=600&seq=movie-14&orientation=portrait",
    description:
      "约翰·威克为了重获自由，不得不与高桌会展开最终对决。他远赴巴黎，面对来自世界各地的顶级杀手，在一场场惊心动魄的搏杀中寻求最后的出路。",
    director: "查德·斯塔赫斯基",
    cast: ["基努·里维斯", "甄子丹", "比尔·斯卡斯加德"],
    releaseDate: "2023-03-24",
    views: 5720000,
    duration: 169,
  },
  {
    id: 15,
    title: "花束般的恋爱",
    type: "movie",
    category: "爱情",
    region: "日韩",
    year: 2021,
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20Japanese%20movie%20poster%20of%20a%20young%20couple%20sharing%20earphones%20on%20a%20train%20platform%20at%20dusk%2C%20soft%20pastel%20pink%20and%20warm%20amber%20tones%2C%20gentle%20nostalgic%20mood%2C%20vertical%20composition&width=400&height=600&seq=movie-15&orientation=portrait",
    description:
      "山音麦与八谷绢因错过末班车而相遇，两人有着惊人相似的爱好，迅速坠入爱河。然而随着时间推移，生活的现实逐渐消磨了曾经的浪漫，一段花束般的恋爱悄然走向终点。",
    director: "土井裕泰",
    cast: ["菅田将晖", "有村架纯", "细田佳央太"],
    releaseDate: "2021-01-29",
    views: 4980000,
    duration: 124,
  },
  {
    id: 16,
    title: "铃芽之旅",
    type: "movie",
    category: "动画",
    region: "日韩",
    year: 2022,
    rating: 7.3,
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20of%20a%20girl%20standing%20before%20a%20glowing%20ancient%20door%20in%20ruins%2C%20starry%20sky%20and%20gentle%20green%20fields%2C%20soft%20teal%20and%20warm%20light%2C%20dreamy%20vertical%20composition&width=400&height=600&seq=movie-16&orientation=portrait",
    description:
      "少女铃芽在一次意外中发现了通往灾难的“门”，为了阻止灾厄降临，她与化为椅子的青年草太踏上了关闭各地之门的旅程，一段关于告别与成长的奇幻冒险就此展开。",
    director: "新海诚",
    cast: ["原菜乃华", "松村北斗", "深津绘里"],
    releaseDate: "2022-11-11",
    views: 4630000,
    duration: 122,
  },
  {
    id: 17,
    title: "寄生虫",
    type: "movie",
    category: "剧情",
    region: "日韩",
    year: 2019,
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20family%20silhouette%20in%20a%20dim%20basement%20staircase%2C%20rain%20streaming%20outside%20a%20window%2C%20muted%20green%20and%20cold%20grey%20tones%2C%20tense%20atmospheric%20mood%2C%20vertical%20composition&width=400&height=600&seq=movie-17&orientation=portrait",
    description:
      "住在半地下室的一家四口，意外发现了一个进入富人家庭工作的机会。他们用尽手段先后“寄生”进豪宅，却因一场意外而卷入无法收拾的悲剧之中，揭示出深刻的社会隐喻。",
    director: "奉俊昊",
    cast: ["宋康昊", "李善均", "曹如晶", "崔宇植"],
    releaseDate: "2019-05-30",
    views: 6120000,
    duration: 132,
  },
  {
    id: 18,
    title: "釜山行",
    type: "movie",
    category: "悬疑",
    region: "日韩",
    year: 2016,
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20Korean%20zombie%20thriller%20poster%20of%20a%20crowded%20train%20corridor%20with%20eerie%20shadows%2C%20emergency%20red%20lights%20and%20cold%20steel%20blue%2C%20suspenseful%20high%20contrast%20vertical%20composition&width=400&height=600&seq=movie-18&orientation=portrait",
    description:
      "一场神秘的病毒疫情爆发，让整个韩国陷入恐慌。在开往釜山的一列高速列车上，乘客们为了生存与丧尸展开殊死搏斗，在绝境中展现出人性的善与恶。",
    director: "延尚昊",
    cast: ["孔刘", "郑有美", "马东锡", "金秀安"],
    releaseDate: "2016-07-20",
    views: 5470000,
    duration: 118,
  },
  {
    id: 19,
    title: "教父",
    type: "movie",
    category: "犯罪",
    region: "欧美",
    year: 1972,
    rating: 9.3,
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20mafia%20drama%20movie%20poster%20of%20a%20stern%20suited%20man%20in%20a%20shadowy%20office%2C%20warm%20amber%20desk%20lamp%20against%20deep%20black%20tones%2C%20timeless%20cinematic%20portrait%2C%20vertical%20composition&width=400&height=600&seq=movie-19&orientation=portrait",
    description:
      "美国纽约五大黑帮家族之一的柯里昂家族，教父维托·柯里昂执掌家族多年，是众多弱小平民的守护神。随着时代变迁，家族权力逐渐交到小儿子迈克尔手中，开启了一段厚重的黑帮传奇。",
    director: "弗朗西斯·福特·科波拉",
    cast: ["马龙·白兰度", "阿尔·帕西诺", "詹姆斯·凯恩"],
    releaseDate: "1972-03-24",
    views: 5810000,
    duration: 175,
  },
  {
    id: 20,
    title: "盗梦空间",
    type: "movie",
    category: "科幻",
    region: "欧美",
    year: 2010,
    rating: 9.4,
    cover:
      "https://readdy.ai/api/search-image?query=Mind%20bending%20sci%20fi%20movie%20poster%20of%20a%20folding%20city%20street%20curving%20into%20the%20sky%2C%20a%20lone%20figure%20below%2C%20steel%20blue%20and%20grey%20tones%2C%20surreal%20cinematic%20lighting%2C%20vertical%20composition&width=400&height=600&seq=movie-20&orientation=portrait",
    description:
      "多姆·柯布是一名技艺高超的窃贼，他的特殊能力是进入他人梦境窃取机密。为了重获失去的一切，他接下一项几乎不可能完成的任务——在目标潜意识深处植入一个想法。",
    director: "克里斯托弗·诺兰",
    cast: ["莱昂纳多·迪卡普里奥", "约瑟夫·高登-莱维特", "艾伦·佩吉"],
    releaseDate: "2010-07-16",
    views: 6530000,
    duration: 148,
  },
  {
    id: 21,
    title: "狂飙",
    type: "tv",
    category: "犯罪",
    region: "国产",
    year: 2023,
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20of%20a%20trench%20coated%20police%20officer%20facing%20a%20shadowy%20city%20street%20at%20night%2C%20teal%20and%20amber%20cinematic%20tones%2C%20tense%20moody%20atmosphere%2C%20vertical%20composition&width=400&height=600&seq=tv-01&orientation=portrait",
    description:
      "2000年，意气风发的刑警安欣与受人欺负的鱼贩高启强相识。随着高启强一步步走向黑暗，两人展开了长达二十年的殊死较量，一段关于正义与沉沦的史诗徐徐展开。",
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐", "张志坚"],
    releaseDate: "2023-01-14",
    views: 10240000,
    episodes: 39,
    status: "完结",
  },
  {
    id: 22,
    title: "三体",
    type: "tv",
    category: "科幻",
    region: "国产",
    year: 2023,
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20series%20poster%20of%20a%20giant%20radio%20telescope%20dish%20under%20a%20starry%20night%20sky%2C%20deep%20indigo%20and%20cool%20cyan%20tones%2C%20vast%20mysterious%20cosmic%20mood%2C%20vertical%20composition&width=400&height=600&seq=tv-02&orientation=portrait",
    description:
      "纳米物理学家汪淼与刑警史强联手，调查一系列科学家自杀背后的神秘事件。随着真相逐渐揭开，一个来自四光年外的三体文明，正悄然逼近地球。",
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    releaseDate: "2023-01-15",
    views: 8910000,
    episodes: 30,
    status: "完结",
  },
  {
    id: 23,
    title: "漫长的季节",
    type: "tv",
    category: "悬疑",
    region: "国产",
    year: 2023,
    rating: 9.4,
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20mystery%20drama%20poster%20of%20a%20middle%20aged%20man%20by%20an%20old%20factory%20railway%20in%20autumn%2C%20faded%20warm%20sepia%20and%20muted%20green%20tones%2C%20melancholic%20vertical%20composition&width=400&height=600&seq=tv-03&orientation=portrait",
    description:
      "桦林钢厂的一桩碎尸案，改变了几个普通人的人生。二十年后，年迈的王响伙同昔日伙伴重新追查旧案，在漫长的季节里与时间赛跑，只为寻回一个迟到的真相。",
    director: "辛爽",
    cast: ["范伟", "秦昊", "陈明昊", "李庚希"],
    releaseDate: "2023-04-22",
    views: 8460000,
    episodes: 12,
    status: "完结",
  },
  {
    id: 24,
    title: "梦华录",
    type: "tv",
    category: "古装",
    region: "国产",
    year: 2022,
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20drama%20poster%20of%20a%20woman%20in%20flowing%20silk%20robe%20by%20a%20misty%20canal%20town%20at%20dusk%2C%20soft%20jade%20green%20and%20warm%20pink%20tones%2C%20refined%20poetic%20mood%2C%20vertical%20composition&width=400&height=600&seq=tv-04&orientation=portrait",
    description:
      "钱塘茶坊老板娘赵盼儿与姐妹孙三娘、宋引章历经波折来到东京。三人携手自立，将一间小茶铺经营成汴京最大的酒楼，也在繁华烟火中收获了各自的爱情与成长。",
    director: "杨阳",
    cast: ["刘亦菲", "陈晓", "柳岩", "林允"],
    releaseDate: "2022-06-02",
    views: 7920000,
    episodes: 40,
    status: "完结",
  },
  {
    id: 25,
    title: "苍兰诀",
    type: "tv",
    category: "奇幻",
    region: "国产",
    year: 2022,
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20Chinese%20drama%20poster%20of%20a%20young%20woman%20in%20moonlit%20ancient%20garden%20with%20glowing%20blue%20lotus%20petals%2C%20soft%20violet%20and%20teal%20tones%2C%20ethereal%20romantic%20vertical%20composition&width=400&height=600&seq=tv-05&orientation=portrait",
    description:
      "魄心族神女在灵力散尽后化作一株仙草，被仙子小兰花悉心照料。阴差阳错间，她与魔尊东方青苍相遇，两个原本对立的存在在朝夕相处中跨越宿命，谱写出一段甜虐交织的仙侠恋歌。",
    director: "伊峥",
    cast: ["虞书欣", "王鹤棣", "徐海乔", "郭晓婷"],
    releaseDate: "2022-08-07",
    views: 7180000,
    episodes: 36,
    status: "完结",
  },
  {
    id: 26,
    title: "繁花",
    type: "tv",
    category: "剧情",
    region: "国产",
    year: 2024,
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Retro%201990s%20Shanghai%20drama%20poster%20of%20a%20suited%20businessman%20under%20warm%20neon%20signs%20of%20an%20old%20street%2C%20amber%20and%20deep%20teal%20tones%2C%20glamorous%20noir%20mood%2C%20vertical%20composition&width=400&height=600&seq=tv-06&orientation=portrait",
    description:
      "上世纪九十年代的上海，改革开放的浪潮席卷而来。青年阿宝在时代洪流中抓住机遇，一步步成长为叱咤商界的宝总，也在繁华的黄河路上经历着情感的起伏与人世的变迁。",
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    releaseDate: "2024-01-09",
    views: 7740000,
    episodes: 30,
    status: "完结",
  },
  {
    id: 27,
    title: "庆余年第二季",
    type: "tv",
    category: "古装",
    region: "国产",
    year: 2024,
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20political%20drama%20poster%20of%20a%20young%20scholar%20amid%20a%20grand%20palace%20hall%20with%20candles%2C%20rich%20crimson%20and%20gold%20tones%2C%20majestic%20cinematic%20lighting%2C%20vertical%20composition&width=400&height=600&seq=tv-07&orientation=portrait",
    description:
      "范闲在庆国经历重重考验后，名声日盛，却也卷入更深的权力漩涡。他在亲情、友情与家国大义之间周旋，一边追寻母亲叶轻眉的秘密，一边在庙堂与江湖间步步为营。",
    director: "孙皓",
    cast: ["张若昀", "李沁", "陈道明", "吴刚"],
    releaseDate: "2024-05-16",
    views: 8160000,
    episodes: 36,
    status: "连载",
  },
  {
    id: 28,
    title: "权力的游戏",
    type: "tv",
    category: "奇幻",
    region: "欧美",
    year: 2011,
    rating: 9.3,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20series%20poster%20of%20a%20lone%20warrior%20before%20a%20vast%20iron%20throne%20in%20a%20dark%20hall%2C%20cold%20steel%20blue%20and%20ember%20orange%2C%20grand%20dramatic%20atmosphere%2C%20vertical%20composition&width=400&height=600&seq=tv-08&orientation=portrait",
    description:
      "在维斯特洛大陆上，七大王国的贵族家族为了铁王座展开残酷的权力争夺。与此同时，绝境长城之外，一个古老而恐怖的威胁正悄然苏醒，长夜将至，唯有强者才能生存。",
    director: "大卫·贝尼奥夫",
    cast: ["艾米莉亚·克拉克", "基特·哈灵顿", "彼特·丁拉基"],
    releaseDate: "2011-04-17",
    views: 9050000,
    episodes: 73,
    status: "完结",
  },
  {
    id: 29,
    title: "怪奇物语",
    type: "tv",
    category: "科幻",
    region: "欧美",
    year: 2016,
    rating: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20sci%20fi%20horror%20series%20poster%20of%20kids%20on%20bikes%20before%20a%20glowing%20portal%20in%20a%20dark%20forest%2C%20neon%20red%20and%20deep%20teal%20tones%2C%20nostalgic%20suspenseful%20vertical%20composition&width=400&height=600&seq=tv-09&orientation=portrait",
    description:
      "1983年，美国小镇霍金斯，一个男孩神秘失踪。他的朋友们在寻找他的过程中，遇见了拥有超能力的女孩十一，也揭开了小镇背后隐藏的国家级秘密实验与颠倒世界的恐怖真相。",
    director: "达菲兄弟",
    cast: ["米莉·波比·布朗", "薇诺娜·瑞德", "大卫·哈伯"],
    releaseDate: "2016-07-15",
    views: 8370000,
    episodes: 34,
    status: "连载",
  },
  {
    id: 30,
    title: "西部世界",
    type: "tv",
    category: "科幻",
    region: "欧美",
    year: 2016,
    rating: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20western%20sci%20fi%20series%20poster%20of%20a%20lone%20rider%20on%20a%20desert%20plain%20under%20a%20strange%20sky%2C%20warm%20sand%20and%20cold%20grey%20tones%2C%20mysterious%20cinematic%20mood%2C%20vertical%20composition&width=400&height=600&seq=tv-10&orientation=portrait",
    description:
      "在一座以美国西部为主题的高科技乐园里，游客可以与高度仿真的机器人尽情互动。然而随着时间推移，这些机器人逐渐产生了自我意识，一场关于觉醒与反抗的风暴正在酝酿。",
    director: "乔纳森·诺兰",
    cast: ["埃文·蕾切尔·伍德", "坦迪·牛顿", "安东尼·霍普金斯"],
    releaseDate: "2016-10-02",
    views: 6920000,
    episodes: 36,
    status: "完结",
  },
  {
    id: 31,
    title: "老友记",
    type: "tv",
    category: "喜剧",
    region: "欧美",
    year: 1994,
    rating: 9.8,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20sitcom%20poster%20of%20six%20friends%20laughing%20in%20a%20cozy%20colorful%20living%20room%2C%20soft%20warm%20amber%20and%20cream%20tones%2C%20cheerful%20nostalgic%20vertical%20composition&width=400&height=600&seq=tv-11&orientation=portrait",
    description:
      "纽约曼哈顿的六个好友，在中央咖啡馆与公寓之间上演着一幕幕平凡而温暖的生活日常。他们的欢笑、争吵与陪伴，构成了一代人心中最经典的友情童话。",
    director: "大卫·克莱恩",
    cast: ["詹妮弗·安妮斯顿", "柯特妮·考克斯", "莉莎·库卓"],
    releaseDate: "1994-09-22",
    views: 8840000,
    episodes: 236,
    status: "完结",
  },
  {
    id: 32,
    title: "半泽直树",
    type: "tv",
    category: "剧情",
    region: "日韩",
    year: 2013,
    rating: 9.2,
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20corporate%20drama%20poster%20of%20a%20determined%20suited%20banker%20in%20a%20glass%20office%20tower%2C%20cool%20blue%20and%20warm%20amber%20tones%2C%20intense%20professional%20mood%2C%20vertical%20composition&width=400&height=600&seq=tv-12&orientation=portrait",
    description:
      "银行职员半泽直树面对上司的陷害与职场的阴暗，始终坚守自己的信条。他以惊人的毅力与智慧步步反击，誓言让那些伤害过他的人受到应有的惩罚。",
    director: "福泽克雄",
    cast: ["堺雅人", "上户彩", "香川照之", "及川光博"],
    releaseDate: "2013-07-07",
    views: 7360000,
    episodes: 20,
    status: "完结",
  },
  {
    id: 33,
    title: "请回答1988",
    type: "tv",
    category: "家庭",
    region: "日韩",
    year: 2015,
    rating: 9.7,
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%201980s%20Korean%20drama%20poster%20of%20neighbors%20gathered%20in%20a%20cozy%20old%20alley%20at%20dusk%2C%20warm%20sepia%20and%20soft%20cream%20tones%2C%20heartwarming%20retro%20mood%2C%20vertical%20composition&width=400&height=600&seq=tv-13&orientation=portrait",
    description:
      "1988年，首尔双门洞的五户人家比邻而居。孩子们在巷子里一起长大，大人们在琐碎的日子里互相扶持，平凡岁月中的温暖亲情与邻里之谊，勾起无数人的青春回忆。",
    director: "申源浩",
    cast: ["李惠利", "朴宝剑", "柳俊烈", "高庚杓"],
    releaseDate: "2015-11-06",
    views: 8720000,
    episodes: 20,
    status: "完结",
  },
  {
    id: 34,
    title: "鱿鱼游戏",
    type: "tv",
    category: "悬疑",
    region: "日韩",
    year: 2021,
    rating: 7.7,
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20survival%20thriller%20series%20poster%20of%20a%20pink%20guarded%20maze%20and%20players%20in%20green%20tracksuits%2C%20bold%20pink%20and%20cold%20teal%20contrast%2C%20tense%20graphic%20vertical%20composition&width=400&height=600&seq=tv-14&orientation=portrait",
    description:
      "数百名债台高筑、走投无路的人受邀参加一场神秘的游戏。为了赢取巨额奖金，他们在童年游戏改编的残酷关卡中互相厮杀，人性的贪婪与绝望被彻底放大。",
    director: "黄东赫",
    cast: ["李政宰", "朴海秀", "郑好娟", "魏化俊"],
    releaseDate: "2021-09-17",
    views: 8590000,
    episodes: 9,
    status: "连载",
  },
];

export const hotVideoIds = [1, 20, 21, 27, 23, 10, 11, 5, 34, 28];